export default __webpack_public_path__ + "static/media/circle-arrow-top-right.e7b6cfc3.svg";